export default {
    template: `
       <section
            class="modal--content rounded-md w-full !overflow-visible relative"
            data-id="email_fundacao_filtros">
            <header
                class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
                <h2 class="text-lg font-medium text-white">Filtros</h2>
                <button
                    type="button"
                    class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
                    data-xclose="modal_padrao_vue">
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
            <div class="flex flex-col gap-24 !p-24 w-full">
                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Fundos: </label>
                    <select-multiple></select-multiple>
                </div>

                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Tags: </label>
                    <select-multiple></select-multiple>
                </div>

                <div class="flex flex-col gap-4 w-full">
                    <label class="text-sm text-neutral-80 font-medium"> Faixas: </label>
                    <q-select></q-select>
                </div>
            </div>
            <div class="w-full flex gap-24 justify-between items-center p-24 !mt-96">
                <button
                    type="button"
                    class="btn h-48 secondary">
                    Limpar Filtros
                </button>
                <button
                    type="button"
                    class="btn h-48 primary">
                    Aplicar Filtros
                </button>
                
            </div>
        </section>


    `

}